import React, { Fragment } from "react";
import { Div } from "components/Base";
import * as STANDARD_MODULES from "@lennd/value-types/src/constants/standard-modules";
import CanUserDo from "components/Global/Security/CanUserDo";

const View = ({}) => <Div>Reports</Div>;

export default View;
